import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m6.219 9.228.387.162.161.387c.525 1.258.787 1.887 1.23 1.887.445 0 .707-.63 1.231-1.887l.162-.387.387-.162c1.258-.524 1.887-.786 1.887-1.23s-.63-.706-1.887-1.23l-.387-.162-.162-.387c-.524-1.258-.786-1.887-1.23-1.887s-.706.63-1.23 1.887l-.162.387-.387.161c-1.258.525-1.887.787-1.887 1.23 0 .445.63.707 1.887 1.231"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 15.5V5.955C14 1.864 12.667.5 8.667.5H2v15zm-1.4-1.4V5.955c0-1.974-.34-2.846-.768-3.283-.418-.428-1.249-.772-3.165-.772H3.4v12.2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarOutlinedSize16Glyph.displayName = 'DocumentStarOutlinedSize16Glyph';
